<template>
  <form @submit.prevent="$emit('submit', finputs)" :disabled="disabled">
    <template  >
      <div class="columns">
        <div class="column">
          <div class="accent">
            <transition-group
              v-on:before-enter="beforeEnter"
              v-on:enter="enter"
              v-on:leave="leave"
              enter-active-class="accordeon"
              leave-active-class="accordeon"
            >
              <template v-for="(field, key) in fdataEditable">
                <template v-if="(showed || field.required)">
                  <label :for="'field_' + key" class="label" :key="'label_' + key">{{ $tc(field.label.toLowerCase(), 1) }}</label>
                  <InputField
                    :field="field"
                    :finput.sync="finputs[key]"
                    @update:finput="$emit(`update:finputs`, $_.set($_.assign({}, finputs), key, $event))"
                    :info="field.help_text"
                    :error="errors[key]"
                    :iclass="''"
                    :autocomplete="field.type === 'primarykey'"
                    :key="'field_' + key"
                    :name="key"
                  ></InputField>
                </template>
              </template>
            </transition-group>
            <div class="field" style="margin-top:0.75rem;" v-if="!$_.every(fdata, 'required')">
              <div class="control">
                <button type="button" class="button is-fullwidth is-primary is-light" @click.prevent="showed = !showed">
                  <span>Дополнительные поля</span>
                  <span class="icon is-small">
                    <i :class="`fas fa-angle-${showed ? 'up' : 'down'}`" aria-hidden="true"></i>
                  </span>
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="column">
          <template v-for="(field, key) in fdataDisabled">
            <template v-if="['document.owner', 'document.organization', 'organization'].includes(key)">
              <label :for="'field_' + key" class="label" :key="'label_' + key">{{ $tc(field.label.toLowerCase(), 1) }}</label>
              <InputField
                :field="field"
                :finput.sync="finputs[key]"
                @update:finput="$emit(`update:finputs`, $_.set($_.assign({}, finputs), key, $event))"
                :info="field.help_text"
                :error="errors[key]"
                :iclass="'is-static'"
                :disabled="true"
                :autocomplete="field.type === 'primarykey'"
                :key="'field_' + key"
                :name="key"
              ></InputField>
            </template>
          </template>
        </div>
      </div>
    </template>
    <!-- кнопки управления формой -->
    <div class="field is-grouped">
      <slot>
        <div class="control">
          <input class="button is-success" type="submit">
        </div>
        <div class="control">
          <input class="button is-light" type="reset" @click="finputs = {}">
        </div>
      </slot>
    </div>
  </form>
</template>
<script>
export default {
  components: {
    InputField: () => import('@/components/Input.vue')
  },
  props: {
    fdata: [Array, Object],
    finputs: Object,
    errors: [Object, Array],
    disabled: Boolean
  },
  data () {
    return {
      showed: false,
      disabledFields: ['document.owner', 'document.organization', 'organization']
    }
  },
  computed: {
    fdataDisabled () {
      return this.$_.pick(this.fdata, this.disabledFields)
    },
    fdataEditable () {
      return this.$_.omit(this.fdata, this.disabledFields)
    }
  },
  methods: {
    beforeEnter (el) {
      el.style.maxHeight = '0px'
    },
    enter (el) {
      el.style.maxHeight = el.scrollHeight + 'px'
    },
    leave (el) {
      el.style.maxHeight = '0'
    }
  }
}
</script>
<style lang="scss">
  .accordeon {
    transition: max-height 0.2s ease-out;
    overflow: hidden;
    transform-origin: top;
  }
</style>
